import type { ReactNode } from 'react'
import { cx } from '../../cx'
import { Badge } from '../Badge/Badge'
import styles from './PlanCard.module.css'

/**
 * Cecha planu. Zapowiedź niesie plakietkę „WKRÓTCE” (fala 9, grupa 167; D107)
 * — cecha bez pokrycia w systemie nie może wyglądać jak dostępna.
 */
export interface PlanCardFeature {
  label: string
  badge?: ReactNode
}

export interface PlanCardProps {
  name: string
  tagline: ReactNode
  /** Sformatowana cena albo „Wycena" dla planu indywidualnego. */
  price: string
  unit: string
  billNote: string
  featured?: boolean
  featuredLabel?: string
  features: readonly PlanCardFeature[]
  cta: ReactNode
  className?: string
}

/** Karta planu w cenniku landingu (spec 07 §5). */
export function PlanCard({
  name,
  tagline,
  price,
  unit,
  billNote,
  featured = false,
  featuredLabel,
  features,
  cta,
  className,
}: PlanCardProps) {
  return (
    <div className={cx(styles.card, featured && styles.featured, className)}>
      {featured && featuredLabel !== undefined ? (
        <Badge className={styles.badge}>{featuredLabel}</Badge>
      ) : null}
      <p className={styles.name}>{name}</p>
      <p className={styles.tagline}>{tagline}</p>
      <div className={styles.price}>
        <span className={styles.amount}>{price}</span>
        <span className={styles.unit}>{unit}</span>
      </div>
      <p className={styles.billNote}>{billNote}</p>
      <div className={styles.cta}>{cta}</div>
      <div className={styles.separator} aria-hidden="true" />
      <ul className={styles.features}>
        {features.map((feature) => (
          <li key={feature.label} className={styles.feature}>
            <svg
              className={styles.check}
              viewBox="0 0 24 24"
              width={16}
              height={16}
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12.5l4.5 4.5L19 7.5" />
            </svg>
            <span>
              {feature.label}
              {feature.badge === undefined ? null : <span className={styles.featureBadge}>{feature.badge}</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
